import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from 'views/MathClub/components/Archive2022';
import Sidebar2025 from '../MathClub2023/components/Sidebar2025';


const MathCCAClass12025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_archive_url: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA1/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA1/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA1/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA1/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA1/5.webp`;



    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                    Fun with Numbers and Shapes                                   
                                </Typography>
                                <br></br>
                               
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Classes: 1  Date: 1 August 2025
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                    The students of Class 1 participated in the Mathematics Inter-House CCA Competition conducted on Friday, 01 August 2025. The Mathematics CCA was conducted in two engaging and creative rounds, designed to integrate art with mathematical concepts.
                                    <br></br>
                                    In the preliminary round, each student participated enthusiastically by drawing animals using numbers and colouring them imaginatively. This round showcased their creativity and understanding of number shapes. 
                                    <br></br>
                                    The final round, held on 1st August 2025, saw selected students from each house take on a hands-on challenge where they designed animals using cut-outs of basic geometric shapes. In addition to the activity, participants were also asked simple questions related to shapes—testing their understanding of names, properties, and recognition of basic shapes like circles, squares, triangles, and rectangles.
                                    <br></br>
                                    This integrated approach not only strengthened their mathematical concepts but also nurtured mathematical thinking in a fun and artistic way, encouraging both imagination and concept application among young learners.
                                    <br></br>
                                   
                                </Typography>
                            </Box>
                            <Typography
                                      variant={'h6'}
                                      color={'primary'}
                                      align={'center'}
                                      fontWeight={'normal'}
                                    ><br/>
                            "Creativity is intelligence having fun"
                            
                            <br/>
                                    </Typography>
                            
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box marginBottom={4}>
                            <Sidebar2025 />
                        </Box>
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default MathCCAClass12025;